module.exports = __webpack_public_path__ + "img/dribble-icon.09972f4f.svg";